import { Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { millisToDays, toSpanishDate } from "../../../helpers/dateFormat";
import {
  numberFormat,
  participationsFormat,
} from "../../../helpers/numberFormat";

export const DetailRealizedStartup = ({ row }) => {
  const {
    participationValuation,
    divestmentParticipation,
    salesPrice,
    investmentDate,
    divestmentDate,
  } = row;
  const amount = divestmentParticipation * participationValuation;
  const { t } = useTranslation("global");

  const newCapital = divestmentParticipation * salesPrice;
  const capitalGain =
    newCapital - row.divestmentParticipation * row.participationValuation;

  const LN = Math.log((amount + capitalGain) / amount);
  const diffDates =
    millisToDays(new Date(divestmentDate) - new Date(investmentDate)) / 365;

  const tir = participationsFormat((Math.exp(LN / diffDates) - 1) * 100) + "%";
  const moic = participationsFormat((amount + capitalGain) / amount) + "x";

  return (
    <>
      <Divider sx={{ margin: "15px 0" }} />
      <Stack
        direction="row"
        flexWrap="wrap"
        gap={1}
        justifyContent="space-between"
      >
        <Stack
          direction="row"
          flexWrap="wrap"
          md={{ justifyContent: "space-between" }}
        >
          <Typography variant="caption" color="primary" marginRight="10px">
            {t("positions.investmentDate")}:{" "}
          </Typography>
          <Typography variant="caption" color="secondary">
            {toSpanishDate(row.investmentDate)}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          flexWrap="wrap"
          md={{ justifyContent: "space-between" }}
        >
          <Typography variant="caption" color="primary" marginRight="10px">
            {t("positions.roundNumber")}:{" "}
          </Typography>
          <Typography variant="caption" color="secondary">
            {row.roundNumber}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          flexWrap="wrap"
          md={{ justifyContent: "space-between" }}
        >
          <Typography variant="caption" color="primary" marginRight="10px">
            {t("positions.amount")}:{" "}
          </Typography>
          <Typography variant="caption" color="secondary">
            {numberFormat(amount)}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          flexWrap="wrap"
          md={{ justifyContent: "space-between" }}
        >
          <Typography variant="caption" color="primary" marginRight="10px">
            {t("positions.participationValuation")}:{" "}
          </Typography>
          <Typography variant="caption" color="secondary">
            {participationValuation
              ? numberFormat(participationValuation)
              : "-"}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          flexWrap="wrap"
          md={{ justifyContent: "space-between" }}
        >
          <Typography variant="caption" color="primary" marginRight="10px">
            {t("positions.shares")}:{" "}
          </Typography>
          <Typography variant="caption" color="secondary">
            {participationsFormat(divestmentParticipation)}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          flexWrap="wrap"
          md={{ justifyContent: "space-between" }}
        >
          <Typography variant="caption" color="primary" marginRight="10px">
            {t("positions.newAmount")}:{" "}
          </Typography>
          <Typography variant="caption" color="secondary">
            {salesPrice}€
          </Typography>
        </Stack>
        <Stack
          direction="row"
          flexWrap="wrap"
          md={{ justifyContent: "space-between" }}
        >
          <Typography variant="caption" color="primary" marginRight="10px">
            {t("positions.capitalGain")}:{" "}
          </Typography>
          <Typography variant="caption" color="secondary">
            {participationsFormat(divestmentParticipation * salesPrice - amount)}€
          </Typography>
        </Stack>
        <Stack
          direction="row"
          flexWrap="wrap"
          md={{ justifyContent: "space-between" }}
        >
          <Typography variant="caption" color="primary" marginRight="10px">
            {t("positions.tir")}:{" "}
          </Typography>
          <Typography variant="caption" color="secondary">
            {tir}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          flexWrap="wrap"
          md={{ justifyContent: "space-between" }}
        >
          <Typography variant="caption" color="primary" marginRight="10px">
            {t("positions.moic")}:
          </Typography>
          <Typography variant="caption" color="secondary">
            {moic}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          flexWrap="wrap"
          md={{ justifyContent: "space-between" }}
        >
          <Typography variant="caption" color="primary" marginRight="10px">
            {t("positions.vehicle")}:{" "}
          </Typography>
          <Typography variant="caption" color="secondary">
            {row.vehicle}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          flexWrap="wrap"
          md={{ justifyContent: "space-between" }}
        >
          <Typography variant="caption" color="primary" marginRight="10px">
            {t("positions.whoInvests")}:{" "}
          </Typography>
          <Typography variant="caption" color="secondary">
            {row.whoInvests}
          </Typography>
        </Stack>
      </Stack>
    </>
  );
};
